<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab tabid="tab-production" :first="true">
        <i class="far fa-code-branch"></i> Production Tree
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage tabid="tab-production" :first="true">
        <div class="row">
          <div class="col-lg-12">
            <h3>Production Tree</h3>
          </div>
        </div>
        <StaticDataTable class="static-table-list production-tree-list" :hover="true" :striped="false" @sortUpdated="productionTree.sortOrder = $event" :key="productionTree.updateKey">
          <template v-slot:header>
            <tr>
              <th>Name</th>
              <th>Category / Type</th>
              <th>Location</th>
              <th>Scanning Options</th>
              <th class="text-center">Active</th>
              <th>View</th>
            </tr>
          </template>
          <template v-slot:body>
            <template v-for="(stage, stageIndex) in productionTree.stageList">
              <tr v-if="stageIndex > 0" class="order-item-spacer" :key="`item-${stageIndex}-spacer`">
                <td colspan="6"> </td>
              </tr>

              <tr :key="stage.id" :data-sort-id="stage.id" class="static-table-sortable production-tree-row" :style="getTreeGroupRowStyles(stage)">
                <td class="font-weight-bold">
                  <LinkProductionStage :id="stage.id" :name="`Stage - ${stage.name}`" :newTab="false" />
                  <LabelBadge v-if="stage.isExternal" labelClass="label-production-stage-external">External</LabelBadge>
                </td>
                <td>{{stage.category | formatLookupName(ProductionStageCategoryTypeLookup)}}</td>
                <td> </td>
                <td> </td>
                <td class="text-center">
                  <IconBoolean :value="stage.isActive" :displayFalse="true" />
                </td>
                <td> </td>
              </tr>
              <template v-if="!productionTree.editing">
                <tr v-for="station in stage.productionStations" class="production-tree-row" :key="`stage-${stage.id}-station-${station.id}`" :style="getTreeGroupRowStyles(stage)">
                  <td>
                    <i class="fas fa-caret-right mr-2 ml-3"></i>
                    <LinkProductionStation :id="station.id" :name="station.name" :newTab="false" />
                    <template v-if="station.secondaryStation">
                      <i class="fas fa-long-arrow-right mr-3 ml-3"></i>
                      <span class="font-italic">{{station.secondaryStation.name}}</span>
                    </template>
                    <LabelBadge labelClass="label-production-maintenance" class="ml-3" v-if="station.isMaintenanceMode"><i class="fas fa-wrench mr-1"></i> In Maintenance</LabelBadge>
                  </td>
                  <td>
                    {{station.type | formatLookupName(ProductionStationTypeLookup)}}
                  </td>
                  <td>
                    {{station.accountLocation ? station.accountLocation.name : '-'}}
                  </td>
                  <td>
                    <LabelBadge labelClass="label-production-scanning-in mr-1" v-if="station.isScanInAvailable"><i class="fas fa-arrow-right mr-1"></i> Scan In</LabelBadge>
                    <LabelBadge labelClass="label-production-scanning-out" v-if="station.isScanOutAvailable"><i class="fas fa-check-circle mr-1"></i> Scan Out</LabelBadge>
                  </td>
                  <td class="text-center">
                    <IconBoolean :value="station.isActive" :displayFalse="true" />
                  </td>
                  <td>
                    <LinkButton 
                      v-if="userHasReadPermission(PermissionTypes.ProductionPermissionTypes.productionStationApp)"
                      :href="`/apps/glass-production-station/${station.id}/stage/${stage.id}`"
                      :newTab="true"
                      colourClass="btn-default"
                      icon="fa-desktop">
                      Station View
                    </LinkButton>
                  </td>
                </tr>                  
              </template>
            </template>
          </template>
        </StaticDataTable>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import DataDisplayMixin from '@/mixins/dataDisplay'

import { ProductionStageCategoryTypeLookup, ProductionStationTypeLookup } from '@/store/types'

export default {
  name: 'TasksConfiguration',
  mixins: [form, DataDisplayMixin],
  data: () => {
    return {
      productionTree: {
        updateKey: 0,
        sortOrder: [],
        form: {},
        stageList: [],
        stationList: []
      }      
    }
  },
  created() {
    this.ProductionStageCategoryTypeLookup = ProductionStageCategoryTypeLookup
    this.ProductionStationTypeLookup = ProductionStationTypeLookup
  },
  mounted() {
    this.requestData()
  },
  computed: {
    
  },
  methods: {
    reloadData() {
      this.requestData()
    },
    requestData() {
      this.pageLoadData(Promise.all([
        this.$apiService.productionService.getProductionStageList(),
        this.$apiService.productionService.getProductionStationList(),
      ]))
      .then(results => {
        this.productionTree.stageList = results[0].data
        this.productionTree.stationList = results[1].data

        this.productionTree.sortOrder = this.productionTree.stageList.map(stage => stage.id)
      })
      .catch(err => this.handlePageLoadError(err))
    },

    // Production Tree
    scanTypeDescription(station) {
      if(station.isScanInAvailable && station.isScanOutAvailable)
        return 'In and Out'
      if(station.isScanInAvailable)
        return 'In Only'
      if(station.isScanOutAvailable)
        return 'Out Only'
      return 'None'
    },

    getTreeGroupRowStyles(group) {
      return {
        'border-left': `4px solid ${group.highlightColour}`
      }
    }
  }
}

</script>